import script from "./TermView.vue?vue&type=script&setup=true&lang=js"
export * from "./TermView.vue?vue&type=script&setup=true&lang=js"

import "./TermView.vue?vue&type=style&index=0&id=b5e1fba2&lang=css"

const __exports__ = script;

export default __exports__